import React from 'react'
import { useNotificationHelper } from '../../utilities/helpers/NotificationHelper';
import Banner from '../banner/Banner';
import Footer from '../footer/Footer';
import PublicHeader from '../header/publicHeader/PublicHeader'
import Notification from '../../components/stateful/notification/Notification';
import './PublicPage.scss'

interface IPublicPage {
    children: any;
    resetPassword?: boolean;
    activateAccount?:boolean;
}

const PublicPage = (props: IPublicPage) => {
    const { notification, removeNotification } = useNotificationHelper();

    return (
        <div className="public-page">
            <a id="skip-nav" className="skiplink-text" href="#main-content">
                Skip to Main Content
            </a>
            {notification.message ? (
                <Notification type={notification.type} closeNotification={() => removeNotification()}>
                    {notification.message}
                </Notification>
            ) : null}
            <Banner />
            <PublicHeader resetPassword={props.resetPassword} activateAccount={props.activateAccount}/>
            <div className="body" role="main" id="main-content">
                {/*<MainContent />*/}
                {props.children}
            </div>
            <Footer />
        </div>
    )
}

export default PublicPage